<template>
  <div id="app">
    <v-app>
      <v-content>
        <!-- <app-toolbar :title="title">
        </app-toolbar>-->
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-progress-linear
                :indeterminate="indeterminate"
                color="green"
                background-color="#fff"
                height="2"
              ></v-progress-linear>
              <v-card>
                <v-responsive :aspect-ratio="19/9">
                  <transition name="slide-x-transition" mode="out-in">
                    <router-view />
                    <!--  Your views display here. -->
                  </transition>
                </v-responsive>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import AppToolbar from "./components/AppToolbar";

export default {
  name: "App",
  components: {
    AppToolbar
  },

  data() {
    return {
      title: "One Cloud"
    };
  },

  computed: {
    indeterminate() {
      return this.$store.getters.indeterminate;
    }
  },
  watch: {
    $route: function(route) {
      switch (route.name) {
        case "googleEmail":
          this.title = "Google Drive";
          break;
        case "outlookEmail":
          this.title = "Sharepoint";
          break;
        case "otherEmail":
          this.title = "Cloud Share";
          break;
      }
    }
  }
};
</script>

<style lang="stylus">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
